import { CACHE_TIME, STALE_TIME } from '@/constants';
import { trpc } from '@/data-loaders';

export const useSchoolUnitDetails = (year: number, schoolId: number, studyPeriodId?: number) => {
  return trpc.schoolUnit.getSchoolUnitDetails.useQuery(
    { year, schoolId, studyPeriodId },
    {
      retry: false,
      cacheTime: CACHE_TIME,
      staleTime: STALE_TIME,
      enabled: !!schoolId && !!year,
    },
  );
};
